export default "assets/images/chateaux-logos/pey-latour-483c61fe.png";